import { SaveButton } from "components/Buttons"
import { CheckboxField, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { Col, Row } from "reactstrap"
import { Field, reduxForm } from "redux-form"

const required = value => (value ? undefined : "Required")

const AdminRoleForm = ({ handleSubmit, handleClose, loading }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs="auto" className="mt-2" style={{ minWidth: "132px" }}>
          <label>Role name:</label>
        </Col>
        <Col>
          <Field name="name" component={TextField} validate={[required]} />
        </Col>
      </Row>
      <Row className="my-3">
        <Col xs="auto" className="mt-2">
          <label>Role description:</label>
        </Col>
        <Col>
          <Field name="description" component={TextField} />
        </Col>
      </Row>
      <Row className="my-1">
        <Col>
          <Field name="mp_only" component={CheckboxField} label="MP only" />
        </Col>
      </Row>
      <Row className="d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={handleClose}
          />
        </Col>
        <Col xs="auto">
          <SaveButton content="Save" loading={loading} />
        </Col>
      </Row>
    </form>
  )
}

export default reduxForm({ form: FORM_NAMES.ADMIN_ROLE })(AdminRoleForm)
